'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // TODO: It might be better to have map of contentId as well, it will improve the search time for GET action


var _contents = require('../actions/contents');

var Actions = _interopRequireWildcard(_contents);

var _channelProfile = require('../actions/channel-profile');

var _contentsHelper = require('../../helpers/contents-helper');

var contentsHelper = _interopRequireWildcard(_contentsHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var contentForGroupsCompleteCount = 0;

var httpRequestStart = function httpRequestStart(state) {
    var isFetching = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return _extends({}, state, {
        isFetching: isFetching,
        errorCode: null
    });
};

var httpRequestFailure = function httpRequestFailure(state, error, call) {
    return _extends({}, state, {
        isFetching: 0,
        isInvalid: true,
        error: {
            isError: true,
            errorCode: error.status,
            errorMessage: error.statusText,
            dataCall: call
        }
    });
};

var addPublicContent = function addPublicContent(state, action) {
    var combinedContents = state.data.slice();
    var publicContents = contentsHelper.publicContents(action.contents);
    if (publicContents) {
        combinedContents = combinedContents.concat(publicContents);
    }
    return combinedContents;
};

var isGroupContentFetchComplete = function isGroupContentFetchComplete(numOfGroups) {
    return numOfGroups === ++contentForGroupsCompleteCount;
};

// TODO: It's default type is Array, but returns object?

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: [], isFetching: 0 };
    var action = arguments[1];

    switch (action.type) {
        case Actions.GET_GROUP_CONTENT_START:
            return httpRequestStart(state, state.isFetching + 1);

        case Actions.GET_GROUP_CONTENT_COMPLETE:
            {
                // TODO: Implementation of pagination
                // const existingPaginatedContent = (state.data || []).filter(function (item){
                //         if(item && item.pageNumber !== action.pageNumber) {
                //             return item;
                //         }
                //     });
                // const paginatedContent = existingPaginatedContent.concat([{pageNumber: action.pageNumber, data:  action.contents}]);
                var combinedContents = addPublicContent(state, action);
                var allGroupContentFetched = isGroupContentFetchComplete(action.numberOfGroups);

                if (allGroupContentFetched) {
                    contentForGroupsCompleteCount = 0;
                }
                return _extends({}, state, {
                    isFetching: state.isFetching - 1,
                    isInvalid: false,
                    data: combinedContents,
                    allGroupContentFetched: allGroupContentFetched
                });
            }

        case _channelProfile.NO_GROUP_DATA:
            return _extends({}, state, {
                allGroupContentFetched: true
            });

        case Actions.GET_GROUP_CONTENT_FAILURE:
            return httpRequestFailure(state, action.error);

        case Actions.CREATE_THUMBNAIL_START:
            return httpRequestStart(state);
        case Actions.CREATE_THUMBNAIL_COMPLETE:
            {
                var updatedThumbnailContents = state.data.filter(function (obj) {
                    if (obj.id === action.contentId) {
                        obj.thumbnail = action.content;
                    }
                    return obj;
                });

                return _extends({}, state, {
                    isFetching: 0,
                    isInvalid: false,
                    data: updatedThumbnailContents
                });
            }
        case Actions.CREATE_THUMBNAIL_FAILURE:
            return httpRequestFailure(state, action.error, action.dataCall);

        case Actions.DELETE_THUMBNAIL_START:
            return httpRequestStart(state);
        case Actions.DELETE_THUMBNAIL_COMPLETE:
            {
                var _updatedThumbnailContents = state.data.filter(function (obj) {
                    if (obj.id === action.contentId) {
                        obj.thumbnail = null;
                        obj.defaultThumbnail = null;
                    }
                    return obj;
                });

                return _extends({}, state, {
                    isFetching: 0,
                    data: _updatedThumbnailContents
                });
            }
        case Actions.DELETE_THUMBNAIL_FAILURE:
            return httpRequestFailure(state, action.error, action.dataCall);
        // Update recording title
        case Actions.UPDATE_RECORDING_TITLE_START:
            return httpRequestStart(state);
        case Actions.UPDATE_RECORDING_TITLE_COMPLETE:
            {
                var updatedTitleContents = state.data.map(function (obj) {
                    if (obj.id === action.contentId) {
                        obj.title = action.content.title;
                    }
                    return obj;
                });

                return _extends({}, state, {
                    isFetching: 0,
                    isInvalid: false,
                    data: updatedTitleContents
                });
            }

        case Actions.UPDATE_RECORDING_TITLE_FAILURE:
            return httpRequestFailure(state, action.error, action.dataCall);

        case Actions.CREATE_CATEGORY_START:
            return httpRequestStart(state);

        case Actions.CREATE_CATEGORY_COMPLETE:
            {
                var updatedContents = state.data.filter(function (obj) {
                    return obj.id !== action.content.id;
                });
                return _extends({}, state, {
                    isFetching: 0,
                    isInvalid: false,
                    data: [action.content].concat(updatedContents)
                });
            }

        case Actions.CREATE_CATEGORY_FAILURE:
            return httpRequestFailure(state, action.error, action.dataCall);

        case Actions.CONTENTS_ERROR_HANDLED:
            return _extends({}, state, {
                error: {
                    isError: false,
                    errorCode: null,
                    errorMessage: null,
                    dataCall: null
                }
            });

        case Actions.RESET_CONTENTS_STATE:
            {
                return {
                    data: [],
                    isFetching: 0,
                    allGroupContentFetched: false
                };
            }

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/contents.js
// module id = 758
// module chunks = 0